// extracted by mini-css-extract-plugin
module.exports = {"footer-links-container":"_84ff5fbbc9--footer-links-container--HEH37","footer-links":"_84ff5fbbc9--footer-links--bVp2H","footer-links-item":"_84ff5fbbc9--footer-links-item--SRoDh"};